import React, { useState, useEffect } from "react";
import { Tabs, Row, Col, Button, Spin } from "antd";
import { isMobile } from "@/utils/public";
import Mxsq from "./mxsq";
import Mxlp from "./mxlp";
import Wdmx from "./wdmx";
import Mxsqsh from "./mxsqsh";
import axios from "axios";
import API from "@/api";

function Mxgl(props) {
  const { activeTab,types,models,tokens, userInfo} = props;
  const [tab, setTab] = useState(activeTab);
  const isMob = isMobile();
  const [spinning, setSpinning] = useState(false);
  const [dTypes,setDTypes] = useState(types);
  const [dModels,setModels] = useState(models);
  const [dTokens,setDTokens] = useState(tokens);
  const tabs = [
    {
      label: "我的模型",
      key: "wdmx",
      children:
        tab === "wdmx" ? (
          <Wdmx
            types={dTypes}
            models={dModels}
            tokens={dTokens}
            userInfo={userInfo}
          />
        ) : undefined,
    },
    {
      label: "模型申请",
      key: "mxsq",
      children:
        tab === "mxsq" ? (
          <Mxsq
            types={dTypes}
            models={dModels}
            tokens={dTokens}
            userInfo={userInfo}
          />
        ) : undefined,
    },
    {
      label: "模型令牌",
      key: "mxlp",
      children: tab === "mxlp" ? <Mxlp /> : undefined,
    },
  ];

  const getUserInfo = () => {
    return axios.get(API.getUserInfo);
  };

  const getModelType = () => {
    return axios.get(API.getModelType);
  };

  const getModelSelectData = () => {
    return axios.get(API.getModelSelectData);
  };

  const getTokenSelectData = () => {
    return axios.get(API.getTokenSelectData);
  };

  useEffect(() => {
    axios
      .all([
        getUserInfo(),
        getModelType(),
        getModelSelectData(),
        getTokenSelectData(),
      ])
      .then(
        axios.spread((res, res1, res2, res3) => {
          const data = res?.data?.result?.data || {};
          const data1 = res1?.data?.result?.data || {};
          const data2 = res2?.data?.result?.data || {};
          const data3 = res3?.data?.result?.data || {};

          const arr = [];
          data1.map((item) => {
            arr.push({
              label: item.name,
              value: item.code,
            });
          });
          setModels(data2);
          setDTokens(data3);
          setDTypes([{ label: "全部", value: "all" }, ...arr]);
          setSpinning(false);
        })
      );
  }, [tab]);

  if (userInfo?.modelAudit) {
    tabs.push({
      label: "模型申请审核",
      key: "check",
      children:
        tab === "check" ? (
          <Mxsqsh
            types={dTypes}
            models={dModels}
            tokens={dTokens}
            userInfo={userInfo}
          />
        ) : undefined,
    });
  }

  return (
    <div className={`${isMob ? "m-zdSearchContent" : "zdSearchContent"}`}>
      <div className="content">
        <Spin spinning={spinning}>
          <Tabs
            activeKey={tab}
            onChange={(activeKey) => {
              setTab(activeKey);
            }}
            style={{
              height: "100%",
            }}
            type="card"
            items={tabs}
            tabBarGutter={15}
          />
        </Spin>
      </div>
    </div>
  );
}

export default Mxgl;
